/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/sara-radio/sara-radio.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import10 from '../../../../node_modules/@angular/forms/src/directives/radio_control_value_accessor.ngfactory';
import * as import11 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import12 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@angular/core/src/linker/element_ref';
import * as import15 from '@angular/forms/src/directives/radio_control_value_accessor';
import * as import16 from '@ngx-translate/core/src/translate.service';
import * as import17 from '@angular/forms/src/directives/default_value_accessor';
import * as import18 from '@angular/forms/src/directives/control_value_accessor';
import * as import19 from '@angular/forms/src/directives/ng_model';
import * as import20 from '@angular/forms/src/directives/ng_control';
import * as import21 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_SaraRadioComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SaraRadioComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  subscription0:any;
  subscription1:any;
  constructor() {
    this._changed = false;
    this.context = new import0.SaraRadioComponent();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_error(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.error = currValue;
      this._expr_0 = currValue;
    }
  }
  check_name(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.name = currValue;
      this._expr_1 = currValue;
    }
  }
  check_show(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.show = currValue;
      this._expr_2 = currValue;
    }
  }
  check_item(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.item = currValue;
      this._expr_3 = currValue;
    }
  }
  check_model(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.model = currValue;
      this._expr_4 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.change.subscribe(_eventHandler.bind(view,'change'))); }
    if (emit1) { (this.subscription1 = this.context.modelChange.subscribe(_eventHandler.bind(view,'modelChange'))); }
  }
}
var renderType_SaraRadioComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SaraRadioComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SaraRadioComponent>;
  _SaraRadioComponent_0_3:Wrapper_SaraRadioComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraRadioComponent_Host0,renderType_SaraRadioComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'sara-radio',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SaraRadioComponent0(this.viewUtils,this,0,this._el_0);
    this._SaraRadioComponent_0_3 = new Wrapper_SaraRadioComponent();
    this.compView_0.create(this._SaraRadioComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SaraRadioComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SaraRadioComponent) && (0 === requestNodeIndex))) { return this._SaraRadioComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SaraRadioComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SaraRadioComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SaraRadioComponentNgFactory:import8.ComponentFactory<import0.SaraRadioComponent> = new import8.ComponentFactory<import0.SaraRadioComponent>('sara-radio',View_SaraRadioComponent_Host0,import0.SaraRadioComponent);
const styles_SaraRadioComponent:any[] = ([] as any[]);
var renderType_SaraRadioComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SaraRadioComponent,{});
export class View_SaraRadioComponent0 extends import2.AppView<import0.SaraRadioComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _DefaultValueAccessor_4_3:import9.Wrapper_DefaultValueAccessor;
  _RadioControlValueAccessor_4_4:import10.Wrapper_RadioControlValueAccessor;
  _NG_VALUE_ACCESSOR_4_5:any[];
  _NgModel_4_6:import11.Wrapper_NgModel;
  _NgControl_4_7:any;
  _NgControlStatus_4_8:import12.Wrapper_NgControlStatus;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  /*private*/ _expr_18:any;
  _pipe_translate_0:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraRadioComponent0,renderType_SaraRadioComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_18 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'span',new import3.InlineArray2(2,'class','eva-3-radio'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'label',new import3.InlineArray2(2,'class','radio-label-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'input',new import3.InlineArray4(4,'class','radio-tag','type','radio'),(null as any));
    this._DefaultValueAccessor_4_3 = new import9.Wrapper_DefaultValueAccessor(this.renderer,new import14.ElementRef(this._el_4));
    this._RadioControlValueAccessor_4_4 = new import10.Wrapper_RadioControlValueAccessor(this.renderer,new import14.ElementRef(this._el_4),this.parentView.injectorGet(import15.RadioControlRegistry,this.parentIndex),this.injector(4));
    this._NG_VALUE_ACCESSOR_4_5 = [
      this._DefaultValueAccessor_4_3.context,
      this._RadioControlValueAccessor_4_4.context
    ]
    ;
    this._NgModel_4_6 = new import11.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_4_5);
    this._NgControl_4_7 = this._NgModel_4_6.context;
    this._NgControlStatus_4_8 = new import12.Wrapper_NgControlStatus(this._NgControl_4_7);
    this._el_5 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','radio-circle'),(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_2,'em',new import3.InlineArray2(2,'class','radio-label'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_11 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray8(8,'change',(null as any),'ngModelChange',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_4));
    this._NgModel_4_6.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._text_11
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.DefaultValueAccessor) && (4 === requestNodeIndex))) { return this._DefaultValueAccessor_4_3.context; }
    if (((token === import15.RadioControlValueAccessor) && (4 === requestNodeIndex))) { return this._RadioControlValueAccessor_4_4.context; }
    if (((token === import18.NG_VALUE_ACCESSOR) && (4 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_4_5; }
    if (((token === import19.NgModel) && (4 === requestNodeIndex))) { return this._NgModel_4_6.context; }
    if (((token === import20.NgControl) && (4 === requestNodeIndex))) { return this._NgControl_4_7; }
    if (((token === import21.NgControlStatus) && (4 === requestNodeIndex))) { return this._NgControlStatus_4_8.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this._DefaultValueAccessor_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_1_0:any = import3.inlineInterpolate(1,'',this.context.name,'');
    this._RadioControlValueAccessor_4_4.check_name(currVal_4_1_0,throwOnChange,false);
    const currVal_4_1_1:any = import3.inlineInterpolate(1,'',this.context.item.id,'');
    this._RadioControlValueAccessor_4_4.check_value(currVal_4_1_1,throwOnChange,false);
    this._RadioControlValueAccessor_4_4.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_2_0:any = import3.inlineInterpolate(1,'',this.context.name,'');
    this._NgModel_4_6.check_name(currVal_4_2_0,throwOnChange,false);
    const currVal_4_2_1:any = this.context.item.disable;
    this._NgModel_4_6.check_isDisabled(currVal_4_2_1,throwOnChange,false);
    const currVal_4_2_2:any = this.context.model;
    this._NgModel_4_6.check_model(currVal_4_2_2,throwOnChange,false);
    this._NgModel_4_6.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_8.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_8.checkHost(this,this,this._el_4,throwOnChange);
    valUnwrapper.reset();
    const currVal_18:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.item.value)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_18,currVal_18))) {
      this.renderer.setText(this._text_8,currVal_18);
      this._expr_18 = currVal_18;
    }
  }
  destroyInternal():void {
    this._RadioControlValueAccessor_4_4.ngOnDestroy();
    this._NgModel_4_6.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_4_3.handleEvent(eventName,$event) && result);
    result = (this._RadioControlValueAccessor_4_4.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.doChange()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.model = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/sara-radio/sara-radio.component.ngfactory.ts